import { InputSkeleton } from '@/_components';

import { FormLayout } from '../../layout';

export default function Loading() {
  return (
    <FormLayout>
      <InputSkeleton className="col-span-12" />
      <InputSkeleton className="col-span-6 lg:col-span-4 2xl:col-span-2" />
      <InputSkeleton className="col-span-6 lg:col-span-4" />
      <InputSkeleton className="col-span-6 lg:col-span-4 2xl:col-span-2" />
      <InputSkeleton className="col-span-6 lg:col-span-4" />
    </FormLayout>
  );
}
